import { render, staticRenderFns } from "./ReportTotals.vue?vue&type=template&id=1fa0b9a6&"
import script from "./ReportTotals.vue?vue&type=script&lang=js&"
export * from "./ReportTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fa0b9a6')) {
      api.createRecord('1fa0b9a6', component.options)
    } else {
      api.reload('1fa0b9a6', component.options)
    }
    module.hot.accept("./ReportTotals.vue?vue&type=template&id=1fa0b9a6&", function () {
      api.rerender('1fa0b9a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/reports/ReportTotals.vue"
export default component.exports